







import Nav from '@/components/Nav.vue'

export default {
  name: 'App',
  components: {
    'sidebar-nav': Nav
  }
}
